import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
import { computed, useSlots, } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CardSection',
    props: {
        title: { default: '' },
        p0: { type: Boolean, default: false },
        m0: { type: Boolean, default: false },
        unsetHeight: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const slots = useSlots();
        const computedWrapperClass = computed(() => {
            const classList = {};
            if (props.unsetHeight) {
                classList['unset-height'] = true;
            }
            if (props.m0) {
                classList.m0 = true;
            }
            return classList;
        });
        const computedTextClass = computed(() => {
            const classList = {};
            if (props.p0) {
                classList.p0 = true;
            }
            // 추가할게 있으면 이쪽에 추가..
            // if (props.foo) {
            //   classList.foo = true;
            // }
            return classList;
        });
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                class: _normalizeClass(["brg-card-outlined card-section", computedWrapperClass.value]),
                elevation: "0",
                outlined: ""
            }, {
                default: _withCtx(() => [
                    (_ctx.title || _unref(slots).titleContent)
                        ? (_openBlock(), _createBlock(_component_v_card_title, {
                            key: 0,
                            class: "contents-title-text"
                        }, {
                            default: _withCtx(() => [
                                (_ctx.title)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                _renderSlot(_ctx.$slots, "titleContent")
                            ]),
                            _: 3 /* FORWARDED */
                        }))
                        : _createCommentVNode("v-if", true),
                    (_ctx.title || _unref(slots).titleContent)
                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_card_text, {
                        class: _normalizeClass(["card-section__body", computedTextClass.value])
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["class"])
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["class"]));
        };
    }
});
